import {SimulatorConfig} from './SimulatorConfig';

export const Configuration = () => {
  return <SimulatorConfig />;
};
